/**
 * Vehicle Name Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.vehicleNameFormatter = function(value, row) {
    if (rights.includes("vehicles.show")) {
        return '<a href="/vehicles/show/'+row.vehicle_id+'">'+value+'</a>';
    } else if (value) {
        return value;
    }
};
